const routes = [
    {
        path: "/vinov/installments",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true ,
            permission:'vinovinstallment_index'

        }
    }
];

export default routes;
